const faTriangleExclamation = {
  prefix: 'fal',
  iconName: 'triangle-exclamation',
  icon: [
    512,
    512,
    [9888, 'exclamation-triangle', 'warning'],
    'f071',
    'M256 32c2.9 0 5.6 1.6 7 4.2l216 400c1.3 2.5 1.3 5.5-.2 7.9s-4.1 3.9-6.9 3.9L40 448c-2.8 0-5.4-1.5-6.9-3.9s-1.5-5.4-.2-7.9l216-400c1.4-2.6 4.1-4.2 7-4.2zm35.2-11C284.2 8.1 270.7 0 256 0s-28.2 8.1-35.2 21L4.8 421c-6.7 12.4-6.4 27.4 .8 39.5S25.9 480 40 480l432 0c14.1 0 27.1-7.4 34.4-19.5s7.5-27.1 .8-39.5L291.2 21zM256 176c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm20 209.3a20 20 0 1 0 -40 0 20 20 0 1 0 40 0z',
  ],
};
export default faTriangleExclamation;
